import React from "react";
import { Link } from "react-router-dom";

/**
 * What to do next, and where to tap to do it.
 *
 * "You have 1 card to enter" tells a player something is wrong without
 * telling them how to put it right. This says the thing, names the round
 * and course, and is itself the button — there's nothing to go and find.
 *
 * tone: "do"     something is waiting on them, red
 *       "wait"   nothing to do yet, quiet
 *       "done"   finished, quiet with a tick
 */
export default function NextStep({ tone = "do", title, detail, action, to, onClick }) {
  const body = (
    <>
      <span className={`step-mark step-${tone}`} aria-hidden="true" />
      <span className="step-text">
        <strong>{title}</strong>
        {detail && <small>{detail}</small>}
      </span>
      {action && <span className="step-go">{action}</span>}
    </>
  );

  if (!to && !onClick) return <div className={`step step-t-${tone}`}>{body}</div>;
  return to
    ? <Link to={to} className={`step step-t-${tone}`}>{body}</Link>
    : <button onClick={onClick} className={`step step-t-${tone}`}>{body}</button>;
}
